import { render, staticRenderFns } from "./Column2ChartMobile.vue?vue&type=template&id=f94404be&scoped=true&"
import script from "./Column2ChartMobile.vue?vue&type=script&lang=js&"
export * from "./Column2ChartMobile.vue?vue&type=script&lang=js&"
import style0 from "./Column2ChartMobile.vue?vue&type=style&index=0&id=f94404be&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94404be",
  null
  
)

export default component.exports